export default {
    // 中
    zhCN: {
        newly_built: '新建',
        unpublished: '未发布',
        validity: '有效性',
        modelInvolved: '涉及车型',
        involvedArea: '涉及区域',
        state: '状态',
        new_car_reporting_level: '新车上报层级',
        confirm_release: '确认发布',
        maintenance: '维护',
        model_maintenance: '车型维护',
        area_maintenance: '区域维护',
        reporting_level: '上报层级',
    },
    // 英
    enUS: {
        newly_built: 'Add',
        unpublished: 'Unpublished',
        validity: 'Validity',
        modelInvolved: 'Model',
        involvedArea: 'Region',
        state: 'Status',
        new_car_reporting_level: 'New car reporting level',
        confirm_release: 'Confirm release',
        maintenance: 'Maintenance',
        model_maintenance: 'Model maintenance',
        area_maintenance: 'Area maintenance',
        reporting_level: 'Reporting level',
    },
    // 德
    deDE: {
        newly_built: 'Hinzugefügt',
        unpublished: 'Unveröffentlicht',
        validity: 'Gültigkeit',
        modelInvolved: 'Modell',
        involvedArea: 'Region',
        state: 'Status',
        new_car_reporting_level: 'Meldungsebene für Neuwagen',
        confirm_release: 'Freigabe bestätigen',
        maintenance: 'Wartung',
        model_maintenance: 'Model- Wartung',
        area_maintenance: 'Bereichswartung',
        reporting_level: 'Berichtsebene',
    },
    // 法
    frFR: {
        newly_built: 'Ajouter',
        unpublished: 'A communiquer',
        validity: 'Validité',
        modelInvolved: 'Modèle',
        involvedArea: 'Région',
        state: 'Statuts',
        new_car_reporting_level: 'Nouveau niveau de reporting des véhicules',
        confirm_release: 'Confirmer la publication',
        maintenance: 'Maintenir',
        model_maintenance: 'Maintenance du modèle',
        area_maintenance: 'Maintenance de la région',
        reporting_level: 'Niveau de reporting',
    },
    // 意大利
    itIT: {
        newly_built: 'Aggiungi',
        unpublished: 'Inédito',
        validity: 'Validità',
        modelInvolved: 'Modello',
        involvedArea: 'Regione',
        state: 'Stato',
        new_car_reporting_level: 'Livello di segnalazione del nuovo veicolo',
        confirm_release: 'Conferma rilascio',
        maintenance: 'Mantenimento',
        model_maintenance: 'Manutenzione del modello',
        area_maintenance: 'Manutenzione dell\'area\'',
        reporting_level: 'Livello di segnalazione',
    },
    // 荷兰
    nlNL: {
        newly_built: 'Toevoegen',
        unpublished: 'Niet gepubliceerd',
        validity: 'Geldigheid',
        modelInvolved: 'Model',
        involvedArea: 'Regio',
        state: 'Staat',
        new_car_reporting_level: 'Nieuw auto rapportageniveau',
        confirm_release: 'Bevestig vrijgave',
        maintenance: 'Onderhoud',
        model_maintenance: 'Model onderhoud',
        area_maintenance: 'Regio onderhoud',
        reporting_level: 'Rapportage niveau',
    },
    // 越南
    viVN: {
        newly_built: 'Mới tạo',
        unpublished: 'Chưa được xuất bản',
        validity: 'Hiệu lực',
        modelInvolved: 'Loại xe',
        involvedArea: 'Vùng',
        state: 'Trạng thái',
        new_car_reporting_level: 'Mức báo cáo xe mới',
        confirm_release: 'Xác nhận phát hành',
        maintenance: 'Bảo trì',
        model_maintenance: 'Bảo trì mô hình',
        area_maintenance: 'Bảo trì khu vực',
        reporting_level: 'Mức báo cáo',
    },
    // 西班牙
    esES: {
        newly_built: 'Nuevo',
        unpublished: 'No publicado',
        validity: 'Validez',
        modelInvolved: 'Modelo de vehículo relacionado',
        involvedArea: 'Región relacionada',
        state: 'Estado',
        new_car_reporting_level: 'Nivel de informe de vehículo nuevo',
        confirm_release: 'Confirmar publicación',
        maintenance: 'Mantenimiento',
        model_maintenance: 'Mantenimiento de modelo de vehículo',
        area_maintenance: 'Mantenimiento de región',
        reporting_level: 'Nivel de informe',
    },
    // 葡萄牙
    ptBR: {
        newly_built: 'Recém construído',
        unpublished: 'Não publicado',
        validity: 'Validade',
        modelInvolved: 'Modelo envolvido',
        involvedArea: 'Área envolvida',
        state: 'Estado',
        new_car_reporting_level: 'Novo nível de relatório de carro',
        confirm_release: 'Confirmar liberação',
        maintenance: 'Manutenção',
        model_maintenance: 'Manutenção de modelo',
        area_maintenance: 'Manutenção da área',
        reporting_level: 'Nível de relatório',
    },
    // 波兰
    plPL: {
        newly_built: 'Nowy',
        unpublished: 'Nieopublikowany',
        validity: 'Ważność',
        modelInvolved: 'Model',
        involvedArea: 'Region',
        state: 'Status',
        new_car_reporting_level: 'Poziom raportowania nowego pojazdu',
        confirm_release: 'Potwiedź wydanie',
        maintenance: 'Serwis',
        model_maintenance: 'Serwis modelu',
        area_maintenance: 'Serwis strefy',
        reporting_level: 'Poziom raportowania',
    },
    // 土耳其
    trTR: {
        newly_built: 'Ekle',
        unpublished: 'Yayınlanmamış',
        validity: 'Geçerlilik',
        modelInvolved: 'Model',
        involvedArea: 'Bölge',
        state: 'Durum',
        new_car_reporting_level: 'Yeni araba rapor seviyesi',
        confirm_release: 'Yayınlamayı doğrula',
        maintenance: 'Bakım',
        model_maintenance: 'Model  bakımı',
        area_maintenance: 'Bölge  bakımı',
        reporting_level: 'Rapor seviyesi',
    },
    // 捷克语
    csCZ: {
        newly_built: 'Přidat',
        unpublished: 'Nezveřejněný',
        validity: 'Platnost',
        modelInvolved: 'Model',
        involvedArea: 'Oblast',
        state: 'Stav',
        new_car_reporting_level: 'Úroveň hlášení nového vozidla',
        confirm_release: 'Potvrďte zveřejnění',
        maintenance: 'Údržba',
        model_maintenance: 'Údržba modelu',
        area_maintenance: 'Údržba areálu',
        reporting_level: 'Úroveň hlášení',
    },
    // 匈牙利语翻译
    huHU: {
        newly_built: 'Hozzáadás',
        unpublished: 'Kiadatlan',
        validity: 'Érvényesség',
        modelInvolved: 'Modell',
        involvedArea: 'Régió',
        state: 'Állapot',
        new_car_reporting_level: 'Új autó jelentési szint',
        confirm_release: 'Kiadás megerősítése',
        maintenance: 'Karbantartás',
        model_maintenance: 'Modell karbantartása',
        area_maintenance: 'Terület karbantartása',
        reporting_level: 'Jelentési szint',
    },
    // 俄罗斯语
    ruRU: {
        newly_built: 'Добавить',
        unpublished: 'Неопубликовано',
        validity: 'Срок действия',
        modelInvolved: 'Модель',
        involvedArea: 'Регион',
        state: 'Статус',
        new_car_reporting_level: 'Уровень отчета о новом автомобиле',
        confirm_release: 'Подтвердить выпуск',
        maintenance: 'Обслуживание',
        model_maintenance: 'Обслуживание модели',
        area_maintenance: 'Обслуживание области',
        reporting_level: 'Уровень отчета',
    },
    // 沙特阿拉伯
    arSA: {
        newly_built: 'جديد الإنشاء',
        unpublished: 'غير منشور',
        validity: 'الصلاحية',
        modelInvolved: 'الطرازات المعنية',
        involvedArea: 'المناطق المعنية',
        state: 'الحالة',
        new_car_reporting_level: 'مستوى إبلاغ السيارات الجديدة',
        confirm_release: 'تأكيد النشر',
        maintenance: 'الصيانة',
        model_maintenance: 'صيانة الطرازات',
        area_maintenance: 'صيانة المناطق',
        reporting_level: 'مستوى الإبلاغ',
    },
    // 保加利亚
    bgBG: {
        newly_built: 'Ново създадено',
        unpublished: 'Не е публикувано',
        validity: 'Валидност',
        modelInvolved: 'Засегнати модели',
        involvedArea: 'Засегнати райони',
        state: 'Състояние',
        new_car_reporting_level: 'Ниво на докладване за нови коли',
        confirm_release: 'Потвърдете публикуването',
        maintenance: 'Поддръжка',
        model_maintenance: 'Поддръжка на модели',
        area_maintenance: 'Поддръжка на райони',
        reporting_level: 'Ниво на докладване',
    },
    // 丹麦语
    daDK: {
        newly_built: 'Nyt oprettet',
        unpublished: 'Ikke offentliggjort',
        validity: 'Gyldighed',
        modelInvolved: 'Inkluderede modeller',
        involvedArea: 'Berørte områder',
        state: 'Status',
        new_car_reporting_level: 'Rapporteringsniveau for nye biler',
        confirm_release: 'Bekræft udgivelse',
        maintenance: 'Vedligeholdelse',
        model_maintenance: 'Modelvedligeholdelse',
        area_maintenance: 'Områdevedligeholdelse',
        reporting_level: 'Rapporteringsniveau',
    },
    // 芬兰语
    fiFI: {
        newly_built: 'Uusi luonti',
        unpublished: 'Julkaisematon',
        validity: 'Voimassaolo',
        modelInvolved: 'Koskettavat mallit',
        involvedArea: 'Koskettavat alueet',
        state: 'Tila',
        new_car_reporting_level: 'Uusien autojen raportointitaso',
        confirm_release: 'Vahvista julkaisu',
        maintenance: 'Ylläpito',
        model_maintenance: 'Mallin ylläpito',
        area_maintenance: 'Alueen ylläpito',
        reporting_level: 'Raportointitaso',
    },
    // 繁体中文台湾
    zhTW: {
        newly_built: '新建',
        unpublished: '未發布',
        validity: '有效性',
        modelInvolved: '涉及車型',
        involvedArea: '涉及區域',
        state: '狀態',
        new_car_reporting_level: '新車上報層級',
        confirm_release: '確認發布',
        maintenance: '維護',
        model_maintenance: '車型維護',
        area_maintenance: '區域維護',
        reporting_level: '上報層級',
    },
    // 克罗地亚
    hrHR: {
        newly_built: 'Novo izgrađeno',
        unpublished: 'Nije objavljeno',
        validity: 'Važećnost',
        modelInvolved: 'Uključeni modeli',
        involvedArea: 'Zahvaćena područja',
        state: 'Stanje',
        new_car_reporting_level: 'Razina prijavljivanja novih vozila',
        confirm_release: 'Potvrdi objavu',
        maintenance: 'Održavanje',
        model_maintenance: 'Održavanje modela',
        area_maintenance: 'Održavanje područja',
        reporting_level: 'Razina prijavljivanja',
    },
    // 拉脱维亚
    lvLV: {
        newly_built: 'Jaunizveidots',
        unpublished: 'Nav publicēts',
        validity: 'Derīgums',
        modelInvolved: 'Ietekmētie modeļi',
        involvedArea: 'Ietekmētie reģioni',
        state: 'Statuss',
        new_car_reporting_level: 'Jauno automobiļu ziņošanas līmenis',
        confirm_release: 'Apstiprināt publicēšanu',
        maintenance: 'Uzturēšana',
        model_maintenance: 'Modeļa uzturēšana',
        area_maintenance: 'Reģiona uzturēšana',
        reporting_level: 'Ziņošanas līmenis',
    },
    // 立陶宛
    ltLT: {
        newly_built: 'Naujai sukurtas',
        unpublished: 'Nepaskelbtas',
        validity: 'Galiojimas',
        modelInvolved: 'Įtraukti modeliai',
        involvedArea: 'Įtrauktos teritorijos',
        state: 'Būsena',
        new_car_reporting_level: 'Naujų automobilių pranešimo lygis',
        confirm_release: 'Patvirtinti paskelbimą',
        maintenance: 'Priežiūra',
        model_maintenance: 'Modelio priežiūra',
        area_maintenance: 'Regiono priežiūra',
        reporting_level: 'Pranešimo lygis',
    },
    // 罗马尼亚
    roRO: {
        newly_built: 'Nou creat',
        unpublished: 'Nepublicat',
        validity: 'Valabilitate',
        modelInvolved: 'Modele implicate',
        involvedArea: 'Zone implicate',
        state: 'Stare',
        new_car_reporting_level: 'Nivel de raportare pentru mașini noi',
        confirm_release: 'Confirmă publicarea',
        maintenance: 'Menținere',
        model_maintenance: 'Menținere modele',
        area_maintenance: 'Menținere zone',
        reporting_level: 'Nivel de raportare',
    },
    // 挪威博克马尔
    nbNO: {
        newly_built: 'Nylig opprettet',
        unpublished: 'Ikke publisert',
        validity: 'Gyldighet',
        modelInvolved: 'Inkluderte modeller',
        involvedArea: 'Berørte områder',
        state: 'Status',
        new_car_reporting_level: 'Rapporteringsnivå for nye biler',
        confirm_release: 'Bekreft utgivelse',
        maintenance: 'Vedlikehold',
        model_maintenance: 'Modellvedlikehold',
        area_maintenance: 'Områdevedlikehold',
        reporting_level: 'Rapporteringsnivå',
    },
    // 葡萄牙语巴西
    ptBX: {
        newly_built: 'Recém-criado',
        unpublished: 'Não publicado',
        validity: 'Validade',
        modelInvolved: 'Modelos envolvidos',
        involvedArea: 'Áreas envolvidas',
        state: 'Estado',
        new_car_reporting_level: 'Nível de reporte de carros novos',
        confirm_release: 'Confirmar publicação',
        maintenance: 'Manutenção',
        model_maintenance: 'Manutenção de modelos',
        area_maintenance: 'Manutenção de áreas',
        reporting_level: 'Nível de reporte',
    },
    // 瑞典语
    svSE: {
        newly_built: 'Nyskapad',
        unpublished: 'Ej publicerad',
        validity: 'Giltighet',
        modelInvolved: 'Inblandade modeller',
        involvedArea: 'Berörda områden',
        state: 'Status',
        new_car_reporting_level: 'Rapportnivå för nya bilar',
        confirm_release: 'Bekräfta publicering',
        maintenance: 'Underhåll',
        model_maintenance: 'Modellunderhåll',
        area_maintenance: 'Områdesunderhåll',
        reporting_level: 'Rapportnivå',
    },
    // 斯洛伐克
    skSK: {
        newly_built: 'Novo vytvorené',
        unpublished: 'Nezverejnené',
        validity: 'Platnosť',
        modelInvolved: 'Zahrnuté modely',
        involvedArea: 'Zahrnuté oblasti',
        state: 'Stav',
        new_car_reporting_level: 'Úroveň hlásenia nových áut',
        confirm_release: 'Potvrďte zverejnenie',
        maintenance: 'Údržba',
        model_maintenance: 'Údržba modelov',
        area_maintenance: 'Údržba oblastí',
        reporting_level: 'Úroveň hlásenia',
    },
    // 斯洛文尼亚
    slSI: {
        newly_built: 'Novo ustvarjeno',
        unpublished: 'Ni objavljeno',
        validity: 'Veljavnost',
        modelInvolved: 'Vključeni modeli',
        involvedArea: 'Vključena območja',
        state: 'Stanje',
        new_car_reporting_level: 'Raven poročanja novih avtomobilov',
        confirm_release: 'Potrdi objavo',
        maintenance: 'Vzdrževanje',
        model_maintenance: 'Vzdrževanje modelov',
        area_maintenance: 'Vzdrževanje območij',
        reporting_level: 'Raven poročanja',
    },
    // 泰语
    thTH: {
        newly_built: 'สร้างใหม่',
        unpublished: 'ยังไม่เผยแพร่',
        validity: 'ความถูกต้อง',
        modelInvolved: 'รุ่นที่เกี่ยวข้อง',
        involvedArea: 'พื้นที่ที่เกี่ยวข้อง',
        state: 'สถานะ',
        new_car_reporting_level: 'ระดับการรายงานรถใหม่',
        confirm_release: 'ยืนยันการเผยแพร่',
        maintenance: 'บำรุงรักษา',
        model_maintenance: 'บำรุงรักษารุ่น',
        area_maintenance: 'บำรุงรักษาพื้นที่',
        reporting_level: 'ระดับการรายงาน',
    },
    // 乌克兰语
    ukUA: {
        newly_built: 'Нове створення',
        unpublished: 'Не опубліковано',
        validity: 'Дійсність',
        modelInvolved: 'Задіяні моделі',
        involvedArea: 'Задіяні регіони',
        state: 'Стан',
        new_car_reporting_level: 'Рівень звітування щодо нових автомобілів',
        confirm_release: 'Підтвердити публікацію',
        maintenance: 'Обслуговування',
        model_maintenance: 'Обслуговування моделей',
        area_maintenance: 'Обслуговування регіонів',
        reporting_level: 'Рівень звітування',
    },
    // 希腊语
    elGR: {
        newly_built: 'Νέα δημιουργία',
        unpublished: 'Μη δημοσιευμένο',
        validity: 'Ισχύς',
        modelInvolved: 'Εμπλεκόμενα μοντέλα',
        involvedArea: 'Εμπλεκόμενες περιοχές',
        state: 'Κατάσταση',
        new_car_reporting_level: 'Επίπεδο αναφοράς νέων αυτοκινήτων',
        confirm_release: 'Επιβεβαίωση δημοσίευσης',
        maintenance: 'Συντήρηση',
        model_maintenance: 'Συντήρηση μοντέλων',
        area_maintenance: 'Συντήρηση περιοχών',
        reporting_level: 'Επίπεδο αναφοράς',
    },
    // 爱沙尼亚
    etEE: {
        newly_built: 'Uus loomine',
        unpublished: 'Avaldamata',
        validity: 'Kehtivus',
        modelInvolved: 'Seotud mudelid',
        involvedArea: 'Seotud alad',
        state: 'Olek',
        new_car_reporting_level: 'Uute autode teavitamise tase',
        confirm_release: 'Kinnita avaldamine',
        maintenance: 'Hooldus',
        model_maintenance: 'Mudeli hooldus',
        area_maintenance: 'Piirkonna hooldus',
        reporting_level: 'Teavitamise tase',
    },
    // 哈萨克
    kkKZ: {
        newly_built: 'Жаңадан құрылған',
        unpublished: 'Жарияланбаған',
        validity: 'Жарамдылық',
        modelInvolved: 'Қамтылған модельдер',
        involvedArea: 'Қамтылған аймақтар',
        state: 'Күйі',
        new_car_reporting_level: 'Жаңа көліктер туралы есеп беру деңгейі',
        confirm_release: 'Жариялауды растау',
        maintenance: 'Техникалық қызмет көрсету',
        model_maintenance: 'Модельге техникалық қызмет көрсету',
        area_maintenance: 'Аймаққа техникалық қызмет көрсету',
        reporting_level: 'Есеп беру деңгейі',
    },
    // 希伯来语
    heIL: {
        newly_built: 'נוצר חדש',
        unpublished: 'לא פורסם',
        validity: 'תוקף',
        modelInvolved: 'דגמים מעורבים',
        involvedArea: 'אזורים מעורבים',
        state: 'סטטוס',
        new_car_reporting_level: 'רמת דיווח על מכוניות חדשות',
        confirm_release: 'אשר פרסום',
        maintenance: 'תחזוקה',
        model_maintenance: 'תחזוקת דגמים',
        area_maintenance: 'תחזוקת אזורים',
        reporting_level: 'רמת דיווח',
    },
};
